module.exports = __webpack_public_path__ + "img/inncash-logo.00686525.webp";